import { storeRef } from "@/components/providers/StoreProvider"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { clearFlatFareConfigCache, fetchFlightProducts } from "./fetchFlightProducts"

export const ensureFlatFareConfigLoaded = async () => {
  if (process.env.NEXT_PUBLIC_WEB !== "B2C") {
    return
  }

  clearFlatFareConfigCache()
  const flatFareConfig = await fetchFlightProducts()
  storeRef.current?.dispatch(flightActions.setFlatFareConfig(flatFareConfig))
}
